import React, {useState, useEffect, useContext} from 'react'
import Navigation from './Navigation';
import Table from './Table';
import AllFilters from './AllFilters';
import LineChart from './LineChart';
import {Errors} from '../../partials/Partials';
import { UserContext } from '../../partials/Context';
import PermissionDenied from '../../partials/PermissionDenied';

function Statystyki() {
    let now = new Date()
    let month_start = new Date(now.getFullYear(), now.getMonth(), 1);

    if(now.getDate() === month_start.getDate()) {
        month_start = new Date(now.getFullYear(), now.getMonth()-1, 1);
    }

    const [stats, setStats] = useState({});
    const [display, setDisplay] = useState(0);
    const [banner_type, setBannerType] = useState(null);
    const [from_date, setFromDate] = useState(month_start);
    const [to_date, setToDate] = useState(now);
    const [chosen_category, setChosenCategory] = useState(null);
    const [referer, setReferer] = useState('');
    const [errors, setErrors] = useState([]);
    const user = useContext(UserContext);
    const {permissions, is_staff} = user || '';
    const [access, setAccess] = useState(false);

    useEffect(() => {
        if (permissions && permissions.indexOf('can_view_stats_api') !== -1) {
            setAccess(true);
        }
    }, [permissions])

    
    let wanted_data = {}

    if (display === 0) {
        wanted_data = {
            'date': 'Data',
            'entries': 'Wejścia ogółem',
            'free_consultations': 'Zamówione bezpłatne konsultacje',
            'paid_consultations': 'Zamówione płatne konsultacje',
            'problems': 'Zadane bezpłatne pytania',
        }
    } else if (display === 1) {
        wanted_data = {
            'date': 'Data',
            'free_consultations': 'Zamówione bezpłatne konsultacje',
            'free_consultations_with_answers' : 'Zamówione bezpłatne konsultacje - obsłużone',
            'entries_with_free_consultations': 'Wejścia, które zakończyły się zamówieniem bezpłatnej konsultacji',
            'entries_with_free_consultations_with_answers': 'Wejścia, które zakończyły się zamówieniem bezpłatnej konsultacji - obsłużone'
        }
    } else if (display === 2) {
        wanted_data = {
            'date': 'Data',
            'paid_consultations': 'Zamówione płatne konsultacje',
            'paid_consultations_with_answers': 'Zamówione płatne    konsultacje - obsłużone',
            'entries_with_paid_consultations': 'Wejścia, które zakończyły się zamówieniem płatnej konsultacji',
            'entries_with_paid_consultations_with_answers': 'Wejścia, które zakończyły się zamówieniem płatnej konsultacji - obsłużone',
        }
    } else if (display === 3) {
        wanted_data = {
            'date': 'Data',
            'problems': 'Zadane bezpłatne pytania',
            'problems_with_answers': 'Zadane bezpłatne pytania - obsłużone',
            'entries_with_problems': 'Wejścia, które z zakończyły się zadaniem bezpłatnego pytania',
            'entries_with_problems_with_answers': 'Wejścia, które z zakończyły się zadaniem bezpłatnego pytania - obsłużone',
        }
    }

 
    useEffect(() => {
        fetch(`/api/analytic-stats/?from_date=${from_date.toISOString().slice(0,10)}&to_date=${to_date.toISOString().slice(0,10)}${banner_type ? `&banner_type=${banner_type}` : ''}${chosen_category ? `&category=${chosen_category}` : ''}${referer ? `&referer=${referer}` : ''}`).then(res => {
            if (res.ok) {
            res.json().then(data => {
                const {stats} = data || []
                let stats_keys = {};
                Object.keys(wanted_data).forEach(key => {
                    stats_keys = {...stats_keys, [key]: []}
                })

                stats.forEach(stat => {
                    Object.keys(stat).forEach(item => {
                        if (stats_keys[item]) {
                            if (item === 'date') {
                                stats_keys[item].push(stat[item].slice(0,10))
                            } else {
                                stats_keys[item].push(stat[item])
                            }
                        }
                    })
                })
                setStats(stats_keys)
                setErrors([])
            })
            } else {
                setErrors(['Nie udało się pobrać danych'])
            }

        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [display, from_date, to_date, chosen_category, banner_type, referer])

    if (access || is_staff) {
    return (
        <div id="wolters-stats">
            <Errors errors={errors} />
            <Navigation display={display} setDisplay={setDisplay}/>
            <AllFilters from_date={from_date} to_date={to_date} setFromDate={setFromDate} setToDate={setToDate} banner_type={banner_type} setBannerType={setBannerType} setChosenCategory={setChosenCategory} setReferer={setReferer} />
            <LineChart stats={stats} wanted_data={wanted_data}/>
            <Table stats={stats} wanted_data={wanted_data}/>
        </div>
    )
    } else {
        return (<PermissionDenied />)
    }
}


export default Statystyki